
import TrueOrFalse from './true-or-false'

import MultipleChoice from './multiple-choice'
import MultipleChoiceProperties from './multiple-choice/properties'

import FillInTheBlanks from './fill-in-the-blanks'
import Matching from './matching'
import OpenQuestion from './open-question'

const handlers = {
  'true-or-false': TrueOrFalse,
  'multiple-choice': MultipleChoice,
  'fill-in-the-blanks': FillInTheBlanks,
  'matching': Matching,
  'open-question': OpenQuestion
}

const propertyHandlers = {
  'multiple-choice': MultipleChoiceProperties
}

export {handlers as default, propertyHandlers}
